import React from 'react';
import { Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { BackSide, Spherical } from 'three';
import { useGesture } from 'react-use-gesture';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { RootState } from '../../../types/data';
import GatewayService from '../../../services/gateway-service';
import { updateAppState } from '../../../store/actions/app';
import { STORY_COORDINATES_FOUND } from '../../../common/constants/gateway-events';

import { useThree } from 'react-three-fiber';

const selectorFn = createSelector<RootState, any, any>(
  store => store.point.current.data,
  _ => _
);

type CoordsSelectSpaceProps = ReturnType<typeof mapDispatchToProps> & React.Props<{}>;

const CoordsSelectSpace = ({ updateAppState }: CoordsSelectSpaceProps) => {
  const point = useSelector(selectorFn);
  const { gl } = useThree();

  const bind = useGesture({
    onClick: ({ event }) => {
      const evt = event as any;
      evt.nativeEvent.preventDefault();
      evt.nativeEvent.stopPropagation();
event.stopPropagation();

      const spherical = new Spherical();
      spherical.setFromVector3((evt as any).point);

      let x = -((spherical.phi * 180) / Math.PI - 90);
      let y = (spherical.theta * 180) / Math.PI - 180;

      const data = {
        x: -y,
        y: -x,
        id: point?.id,
      };

      GatewayService.emit(STORY_COORDINATES_FOUND, data);
      updateAppState({
        coordsSelectEnabled: false,
      });
    },
    onHover: ({ hovering, event }) => {
      const evt = event as any;
      evt.nativeEvent.preventDefault();
      evt.nativeEvent.stopPropagation();
event.stopPropagation();

      if (hovering) {
        setTimeout(() => {
          gl.domElement.classList.add('cursor-icon');
        });
      } else {
        gl.domElement.classList.remove('cursor-icon');
      }
    },
  });

  return (
    <group>
      <mesh renderOrder={100} {...bind()}>
        <sphereBufferGeometry attach="geometry" args={[0.5, 32, 32]} />
        <meshBasicMaterial attach="material" side={BackSide} transparent color="#fff" opacity={0.5} />
      </mesh>
    </group>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      updateAppState,
    },
    dispatch
  );

export default connect(undefined, mapDispatchToProps)(CoordsSelectSpace);
